import React from 'react'
import { Table, Typography } from 'antd'
import { Link, generatePath } from 'react-router-dom'
import _ from 'lodash'

import { ScreenSpin } from 'admin/lib/ScreenSpin'
import { Queries } from 'admin/lib/Api'
import * as ROUTES from 'admin/routes'

export function BIReportsList() {
  const accounts = Queries.useAccounts({ scope: 'global' })
  const biReports = Queries.useBIReports()

  const isFetched = accounts.isFetched && biReports.isFetched
  const isError = accounts.isError || biReports.isError

  const filterEntries = _.uniq(accounts?.data?.map(a => a.name)).map(acc => {
    return { text: acc, value: acc }
  })

  const columns = [
    {
      title: 'Account Name',
      dataIndex: 'accountName',
      filters: filterEntries,
      sorter: (a, b) => a.accountName.localeCompare(b.accountName),
      filterMode: 'menu',
      filterSearch: true,
      onFilter: (value, account) => account.accountName.startsWith(value)
    },
    {
      title: 'Dashboard',
      dataIndex: 'dashboard',
      sorter: (a, b) => a.dashboard.localeCompare(b.dashboard)
    },
    {
      title: 'Professional',
      dataIndex: 'professional',
      sorter: (a, b) => a.professional.localeCompare(b.professional)
    },
    {
      title: '',
      key: 'edit',
      render: biReport => (
        <Typography.Text>
          <Link
            to={generatePath(ROUTES.BI_REPORTS.EDIT, {
              accountId: biReport.accountId
            })}
          >
            Edit
          </Link>
        </Typography.Text>
      )
    }
  ]

  return (
    <>
      {!isFetched && <ScreenSpin />}

      {isError && (
        <div>
          {accounts.isError ? String(accounts.error) : String(biReports.error)}
        </div>
      )}

      {isFetched && biReports.data && accounts.data && (
        <Table
          columns={columns}
          dataSource={assembleReports(accounts.data, biReports.data)}
          rowKey="accountId"
          pagination={false}
          style={{ width: '70%', height: '100%' }}
        />
      )}
    </>
  )
}

function assembleReports(accountData, biReportsData) {
  const professionalReps = _.keyBy(
    _.filter(
      biReportsData,
      rep => rep.reportType.toLowerCase() === 'professional'
    ),
    rep => rep.accountId
  )
  const dashboardReps = _.keyBy(
    _.filter(
      biReportsData,
      rep => rep.reportType.toLowerCase() === 'dashboard'
    ),
    rep => rep.accountId
  )

  const result = accountData.map(acc => {
    return {
      accountId: acc.accountId,
      accountName: acc.name,
      professional: _.get(professionalReps, acc.accountId)?.reportName ?? '',
      dashboard: _.get(dashboardReps, acc.accountId)?.reportName ?? ''
    }
  })

  return result
}

BIReportsList.propTypes = {}
